import { render, staticRenderFns } from "./ShortAnswer.vue?vue&type=template&id=4b326e98&scoped=true"
import script from "./ShortAnswer.vue?vue&type=script&lang=ts"
export * from "./ShortAnswer.vue?vue&type=script&lang=ts"
import style0 from "./ShortAnswer.vue?vue&type=style&index=0&id=4b326e98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b326e98",
  null
  
)

export default component.exports